import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import _ from 'lodash';
import { Checkbox } from '@/core/Checkbox.atom';

type LabelOptions<T extends string | boolean> = {
  id: string;
  value: T;
  label: string;
};

interface LabelSelectionProps<T extends string | boolean> {
  property: string;
  labelValue: T;
  setProperty: (value: T) => void;
  options: LabelOptions<T>[];
  labelTitle: string;
}

export const LabelSelection = <T extends string | boolean>({
  property,
  labelValue,
  labelTitle,
  options,
  setProperty,
}: LabelSelectionProps<T>): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <div
      className="flexColumnContainer flexSpaceBetween pl10 flexAlignCenter"
      data-testid={`${property}-labelSelection`}>
      <div>{t(labelTitle)}:</div>
      <div className="flexColumnContainer ml10">
        {_.map(options, (option) => (
          <Checkbox
            key={`${option.id}_checkbox`}
            classes={clsx('cursorPointer', 'mb5', 'mt8', 'min-width-70')}
            type="radio"
            id={`${property}-${option.id}`}
            label={option.label}
            isChecked={labelValue === option.value}
            onClick={() => setProperty(option.value)}
          />
        ))}
      </div>
    </div>
  );
};
